import styled from "styled-components";

import * as Types from "Types";

import AtomArtmapLogo from "Components/Atoms/ArtmapLogo";

const Wrap = styled.div<Types.Default>`
   margin-top: 110px;
   ${({ css }) => css}
`;

const ArtmapLogo = styled(AtomArtmapLogo)`
   height: 32px;
`;

export default function SectionHead(props: Types.Default) {
   return (
      <Wrap {...props}>
         <ArtmapLogo />
      </Wrap>
   );
}
